import {useReducer, useEffect} from 'react'
import {graphql, useStaticQuery} from 'gatsby'

import {checkExtension} from '../modules'

export const EXT_DOWNLOAD = 'EXT_DOWNLOAD'
export const EXT_NO_SUPPORT = 'EXT_NO_SUPPORT'
export const EXT_INSTALLED = 'EXT_INSTALLED'

const extReducer = (messages) => (state, action) => {
  if (action.type === EXT_DOWNLOAD) {
    return state.map((extension) => {
      if (extension.tag !== action.payload.tag) return extension

      return {...extension, loading: false, downloadLink: action.payload.downloadLink}
    })
  }

  if (action.type === EXT_NO_SUPPORT) {
    return state.map((extension) => {
      if (extension.tag !== action.payload.tag) return extension

      return {
        ...extension,
        loading: false,
        message: messages.unable,
      }
    })
  }

  if (action.type === EXT_INSTALLED) {
    return state.map((extension) => {
      if (extension.tag !== action.payload.tag) return extension

      return {
        ...extension,
        loading: false,
        message: messages.installed,
      }
    })
  }

  return state
}

const commonDataQuery = graphql`
  query {
    common: commonJson {
      messages {
        unable
        installed
      }
    }
  }
`

export function useExtensions(initExtState) {
  const {common} = useStaticQuery(commonDataQuery)
  const [extensions, dispatch] = useReducer(extReducer(common.messages), initExtState, initExtFunc)

  useEffect(() => {
    const installed = (tag) => () => {
      dispatch({
        type: EXT_INSTALLED,
        payload: {
          tag,
        },
      })
    }

    const noSupport = (tag) => () => {
      dispatch({
        type: EXT_NO_SUPPORT,
        payload: {
          tag,
        },
      })
    }

    const doDownload = (tag) => (downloadLink) => {
      dispatch({
        type: EXT_DOWNLOAD,
        payload: {
          tag,
          downloadLink,
        },
      })
    }

    const timeoutId = setTimeout(() => {
      extensions.forEach((ext) => {
        checkExtension(ext, installed(ext.tag), noSupport(ext.tag), doDownload(ext.tag))
      })
    }, 50)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [])

  return extensions
}

function initExtFunc(extensions) {
  return extensions.map((extension) => {
    return {...extension, loading: true, downloadLink: null, message: null}
  })
}
